<template>
  <div>
    <v-btn
      icon
      elevation="0"
      @click.stop="openMenu"
      small
    >
      <v-icon>bhi-dots-vertical</v-icon>
    </v-btn>
    <v-menu 
      rounded 
      absolute 
      offset-x 
      transition="false"
      v-model="showMenu"
      :position-x="x"
      :position-y="y">
      <v-list class="sequences__more--menu" v-if="!collectionMode">
        <v-list-item v-if="assignable" link dense @click="$emit('assign', id, version)">
          <v-list-item-icon>
            <v-icon>bhi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Assign
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click="$emit('edit', id, version)">
          <v-list-item-icon>
            <v-icon>bhi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Edit
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click="$emit('duplicate', id, version)">
          <v-list-item-icon>
            <v-icon>bhi-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Duplicate
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click="$emit('rename-trigger', id, version)">
          <v-list-item-icon>
            <v-icon>bhi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Rename
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click="$emit('delete', id, version)">
          <v-list-item-icon>
            <v-icon>bhi-trash</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Remove
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="sharable" link dense @click="$emit('share', id, version)">
          <v-list-item-icon>
            <v-icon>bhi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Share
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list class="sequences__more--menu" v-else>
        <v-list-item link dense @click="$emit('import', id)">
          <v-list-item-icon>
            <v-icon>bhi-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Import
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click="$emit('preview', id)">
          <v-list-item-icon>
            <v-icon>bhi-loupe</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
                Preview
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'SequenceMoreMenu',
  components: {
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    version: {
      type: Number,
      default: 0
    },
    menu: {
      type: [Boolean, String],
      default: false // other is 'more' or 'browser'
    },
    assignable: {
      type: Boolean,
      default: false
    },
    sharable: {
      type: Boolean,
      default: false
    },
    draft: {
      type: Boolean,
      default: false
    },
    collectionMode: {
      type: Boolean,
      default: false
    },
    imported: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      x: 0,
      y: 0,
      showMenu: false
    }
  },
  computed: {
  },
  methods: {
    openMenu(e) {
      e.stopPropagation()
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    closeMenu() {
      this.showMenu = false
    }
  }
}
</script>

<style lang="scss">
.sequences {
  &__more {
    width: 32px;
    flex-shrink: 0;
    text-align: center;
    position: absolute;
    top:4px;
    right: 0;
    opacity: 0;
    -webkit-transition-duration: 150ms;
    -moz-transition-duration: 150ms;
    -ms-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;
    .v-btn {
      padding: 0;
      background: $bh-blue--4;
      .v-icon {
        color: $bh-blue--3;
      }
      &:hover, &:focus {
        .v-icon {
          color: $bh-blue;
        }
      }
    }
    &--menu {
      width: 148px;
      .v-list-item__icon {
        margin-right: 12px !important;
        text-align: center;
        display: block;
        .v-icon {
          color: $bh-blue;
        }
      }
      .v-list-item__title {
        font-weight: bold;
        font-size: 1rem;
        color: $bh-blue;
      }
    }
  }
}
</style>